import { 
  ChatsCircle, Trophy, MonitorPlay, Microphone, Users, GameController 
} from '@phosphor-icons/react';

const features = [
  {
    icon: <ChatsCircle size={32} weight="fill" />,
    title: 'Real-Time Chat',
    description: 'Connect with gamers worldwide through instant messaging with emoji support.'
  },
  {
    icon: <MonitorPlay size={32} weight="fill" />,
    title: 'Watch Streams',
    description: 'Watch live gameplay streams side-by-side while chatting with your community.'
  },
  {
    icon: <Trophy size={32} weight="fill" />,
    title: 'Leaderboards',
    description: 'Compete for the top spot and track your ranking against players worldwide.'
  },
  {
    icon: <Microphone size={32} weight="fill" />,
    title: 'Voice Notes',
    description: 'Send voice messages to communicate faster during intense gaming sessions.'
  },
  {
    icon: <Users size={32} weight="fill" />,
    title: 'Gaming Profiles',
    description: 'Build your gamer identity with stats, achievements, and customizable profiles.'
  },
  {
    icon: <GameController size={32} weight="fill" />,
    title: '400+ Games',
    description: 'Access a massive library of free-to-play games from around the world.'
  }
];

export const FeaturesSection = () => {
  return (
    <section id="features" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-[#09090B] mb-4">
            Everything You Need
          </h2>
          <p className="text-lg text-[#71717A] max-w-2xl mx-auto">
            Built for gamers, by gamers. Experience the ultimate platform for gaming communities.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature) => (
            <div 
              key={feature.title}
              className="p-8 border border-[#E4E4E7] hover:border-[#0047FF] transition-colors group"
            >
              <div className="w-16 h-16 bg-[#FAFAFA] group-hover:bg-[#0047FF] flex items-center justify-center mb-6 transition-colors">
                <div className="text-[#0047FF] group-hover:text-white transition-colors">
                  {feature.icon}
                </div>
              </div>
              <h3 className="font-heading text-xl font-bold text-[#09090B] mb-3">
                {feature.title}
              </h3>
              <p className="text-[#71717A]">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
